import { tr } from '../i18n/tr';

/**
 * v3.9 alan navigasyonu metinleri. Alan ve Yönetim kategorisi ADLARI arayüz dili sözlüğünden gelir (`tr.nav`, İngilizce
 * paket örter); kısa açıklamalar, bölüm başlıkları ve Yönetim ayarlarının kart/arama açıklamaları Türkçedir (paket kısmi:
 * örtüde olmayan metin Türkçeye düşer). Menü öğe adlarının kendisi tr.ts ve modül metin dosyalarında kalır.
 */
export const navText = {
  areas: {
    bugun: {
      label: tr.nav.today,
      description: 'Genel bakış, bekleyen işler ve ekibin haber akışı.',
    },
    crm: { label: tr.nav.areaCrm, description: 'Müşteri adayları, kişiler ve şirketler.' },
    satis: {
      label: tr.nav.sales,
      description: 'Fırsattan sözleşmeye satış süreci ve ürün kataloğu.',
    },
    iletisim: { label: tr.nav.areaComms, description: 'Gelen kutusu ve destek talepleri.' },
    pazarlama: {
      label: tr.nav.areaMarketing,
      description: 'Aday merkezi, kaynak ve kampanya sonuçları, reklamlar.',
    },
    isler: { label: tr.nav.areaWork, description: 'Görevler, takvim, formlar ve otomasyon.' },
    raporlar: {
      label: tr.nav.areaReports,
      description: 'Performans, hedefler ve ekip raporları.',
    },
    yonetim: {
      label: tr.nav.administration,
      description: 'Çalışma alanının ayarları ve yönetimi.',
    },
  },
  sections: {
    crmLeads: 'Müşteri adayları',
    crmRecords: 'Kişi ve şirketler',
    salesProcess: 'Süreç',
    salesDocuments: 'Belgeler',
    salesCatalog: 'Katalog',
    workTasks: 'Görevler',
    workForms: 'Formlar ve otomasyon',
    workDelivery: 'Teslim',
  },
  admin: {
    hubTitle: 'Yönetim merkezi',
    /** Kategori sayısı kullanıcının gördüğü kategorilerdir (yetkiye göre süzülür; sabit "beş" yazılmaz) */
    hubDescription: (categories: number) =>
      `Yetkinize açık ayarlar ${String(categories)} kategoride. Aradığınız ayarı adıyla ya da ne işe yaradığıyla bulun.`,
    hubBack: 'Yönetim merkezi',
    categoriesSection: 'Kategoriler',
    searchLabel: 'Ayar ara',
    searchPlaceholder: 'Ayar ara: ör. e-posta, kullanıcı, IP',
    searchEmpty: (q: string) => `“${q}” ile eşleşen ayar yok. Başka bir sözcük deneyin.`,
    searchResults: (n: number) => `${String(n)} ayar bulundu`,
    settingsCount: (n: number) => `${String(n)} ayar`,
    openCategory: (label: string) => `${label} kategorisini aç`,
    categoryNotFound: 'Bu kategori yok ya da görme yetkiniz yok.',
    categories: {
      kurulus: {
        label: tr.nav.adminOrg,
        description: 'Kullanıcılar, şirket bilgileri ve çalışma takvimi.',
      },
      kurallar: {
        label: tr.nav.adminRules,
        description: 'Modül ayarları, görünüm, dağıtım ve kampanya kuralları.',
      },
      baglantilar: {
        label: tr.nav.adminConnections,
        description: 'Kanallar, e-posta, entegrasyonlar ve gelen aday uçları.',
      },
      plan: {
        label: tr.nav.adminPlanUsage,
        description: 'Planınızın tavanları ve güncel kullanım.',
      },
      veri: {
        label: tr.nav.adminData,
        description: 'Veri saklama, denetim kayıtları, destek erişimi ve güvenlik.',
      },
    },
    items: {
      users: 'Ekip üyelerinin daveti, rolleri ve erişimleri.',
      'company-settings': 'Şirket adı, adres, vergi ve para birimi bilgileri.',
      'work-calendar': 'Çalışma günleri, saatleri ve tatiller; süre hesapları buna göre yapılır.',
      settings: 'Modül ayarları, özel alanlar, haber akışı ve sözlükler.',
      appearance: 'Menüde görünen bölümler, liste varsayılanları ve arayüz dili.',
      'gamification-settings': 'Puan kuralları, oyunlar ve rozetler.',
      'distribution-rules': 'Gelen adayların ekibe ağırlıklı ve takvimli dağıtımı.',
      acquisition: 'Kampanya sözlüğü, kaynak eşlemeleri ve tıklama kimliği tercihi.',
      'sales-settings': 'Teklif şablonları, içerik blokları ve indirim kampanyaları.',
      'feed-settings': 'Not etiketleri ve haber akışında yayınlanan olaylar.',
      channels: 'Gelen kutusuna bağlı kanallar ve e-posta bastırma listesi.',
      'quick-replies': 'Kişisel ve ekip hazır yanıtları.',
      email: 'SMTP sunucusu, e-posta şablonları ve gönderim kaydı.',
      'inbound-email': 'Gelen e-posta hesapları ve karantina.',
      connections: 'Reklam ve mesajlaşma hesabı bağlantılarının durumu.',
      agents: 'Ajan profilleri, bağlı uygulamalar ve demo çalışma alanında ajan sınaması.',
      integrations: 'Çalışan entegrasyonların kataloğu ve durumu.',
      webhooks: 'Olay abonelikleri, teslim geçmişi ve başarısız teslimler.',
      'public-links': 'Aday web formu ve teklif müşteri bağlantısı ayarları.',
      'lead-endpoints': 'İmzalı web kancası ve potansiyel müşteri formu uçları.',
      plan: 'Planınızın tavanları ve güncel kullanım.',
      'data-lifecycle': 'Saklama süreleri, kişi verisi talepleri, silme defteri ve hesap kapatma.',
      audit: 'Çalışma alanındaki işlemlerin süzgeçli kaydı ve dışa aktarımı.',
      'support-access': 'Castinflow desteğine süreli, salt-okunur erişim izni.',
      'ip-allowlist': 'Girişe izin verilen IP adresleri (kilitlenme korumalı).',
      'quarantined-jobs': 'Geri yükleme sonrası bekleyen dış etkili işlerin incelemesi.',
    } as Readonly<Record<string, string>>,
    salesSettings: 'Satış ayarları',
    feedSettings: 'Haber akışı ayarları',
  },
  quickAccess: {
    title: 'Hızlı erişim',
    hint: 'Sık kullandığınız sayfaları yıldızla buraya sabitleyin.',
    pin: (label: string) => `Hızlı erişime ekle: ${label}`,
    unpin: (label: string) => `Hızlı erişimden çıkar: ${label}`,
    limit: (n: number) => `Hızlı erişime en çok ${String(n)} sayfa eklenebilir.`,
  },
  goToPages: 'Sayfalar',
  pagesFound: (n: number) => `${String(n)} sayfa`,
} as const;
